export const PLAIN = 'plain';
export const MAIN_LAYOUT = 'main';
export const SETTINGS_LAYOUT = 'settings_layout';
